export default __webpack_public_path__ + "static/card-4-b877d07b7441de22990b77e9ce398daf.png";